import RegistrationGrid from "./RegistrationGrid";


const RegistrationVendorMaster = () => {
  return (
    <>
      
      <RegistrationGrid/>
    </>
  );
};

export default RegistrationVendorMaster;